
<app-header></app-header>
<mat-card class="step-card" style="margin-top: 50px;">
  <mat-card-header>
    <mat-card-title>

    </mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">

  </mat-card-actions>
</mat-card>
